// alterado - revisado

import React from 'react'

import MUIDataTable from 'mui-datatables'

import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'

import LABEL from '../../business-const/Label/Label'

import BreadcrumbPadrao from '../../business-components/Breadcrumb/Breadcrumb'

import {
    DivFormN0,
    DivFormN1,
} from '../../business-components/Div/Div'

//import {
//    COLOR
//} from '../../business-const/Color/Color'



export const MUIDataTablePadrao = props => {

    const getMuiTheme = () =>
      createTheme({
        overrides: {
        //  MUIDataTableBodyCell: {
        //    root: {
        //      '&:nth-of-type(odd)': {
        //          backgroundColor: COLOR().corBgTabelasCabecalho,
        //      },
        //    },
        //  },
        },
      });
                    
    const { breadcrumbRouteSegments, customToolbar, columns, ...rest } = props

    columns?.forEach ((linha, ind) => {
        linha.label = 
          <div
            className='ml--0 font-bold text-16'
            align='left'
            style={{ textTransform: 'capitalize' }}
            dangerouslySetInnerHTML={{ __html: linha.label }}
          />
    })



    return (
        <DivFormN0>
            {breadcrumbRouteSegments
                ?
                    <DivFormN1>
                        <BreadcrumbPadrao
                            routeSegments={breadcrumbRouteSegments}
                        />
                    </DivFormN1>
                :
                    ''
            }
            <DivFormN1>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        options={{
                            customToolbar: customToolbar,
                            sort: false,
                            filterType: 'textField',
                            responsive: 'standard',
                            selectableRows: props.selectableRows ? props.selectableRows : 'none',
                            selectableRowsHeader: props.selectableRowsHeader,
                            //disableToolbarSelect: props.disableToolbarSelect, // deprecation
                            selectToolbarPlacement: 
                              props.selectToolbarPlacement ? props.selectToolbarPlacement : 'replace',
                            onRowsDelete: props.onRowsDelete,
                            // onRowsSelect: props.onRowsSelect, // deprecation
                            onRowSelectionChange: props.onRowSelectionChange,
                            search: props.notSearch ? false : true,
                            download: props.notDownload ? false : true,
                            print: props.notPrint ? false : true,
                            viewColumns: props.notViewColumns ? false : true,
                            filter: props.notFilter ? false : true,
                            pagination: true,
                            jumpToPage: true,
                            elevation: 0,
                            rowsPerPage: props.rowsPerPage ? props.rowsPerPage : 10,
                            onChangeRowsPerPage: props.onChangeRowsPerPage,
                            rowsPerPageOptions: [1, 3, 4, 5, 10, 20, 40, 80, 100],
                            textLabels: {
                                body: {
                                  noMatch: LABEL.MUIDataTableNoMatch,
                                  toolTip: LABEL.MUIDataTableToolTip,
                                  columnHeaderTooltip: column => `${LABEL.MUIDataTableColumnHeaderTooltip} ${column.label}`
                                },
                                pagination: {
                                  next: LABEL.MUIDataTablePaginationNext,
                                  previous: LABEL.MUIDataTablePaginationPrevious,
                                  rowsPerPage: LABEL.MUIDataTablePaginationRowsPerPage,
                                  displayRows: LABEL.MUIDataTablePaginationDisplayRows,
                                  jumpToPage: LABEL.MUIDataTablePaginationJumpToPage,
                                },
                                toolbar: {
                                  search: LABEL.MUIDataTableToolbarSearch,
                                  downloadCsv: LABEL.MUIDataTableToolbarDownloadCsv,
                                  print: LABEL.MUIDataTableToolbarPrint,
                                  viewColumns: LABEL.MUIDataTableToolbarViewColumns,
                                  filterTable: LABEL.MUIDataTableToolbarFilterTable,
                                },
                                filter: {
                                  all: LABEL.MUIDataTableFilterAll,
                                  title: LABEL.MUIDataTableFilterTitle,
                                  reset: LABEL.MUIDataTableFilterReset,
                                },
                                viewColumns: {
                                  title: LABEL.MUIDataTableViewColumnsTitle,
                                  titleAria: LABEL.MUIDataTableViewColumnsTitleAria,
                                },
                                selectedRows: {
                                  text: LABEL.MUIDataTableSelectedRowsText,
                                  delete: LABEL.MUIDataTableSelectedRowsDelete,
                                  deleteAria: LABEL.MUIDataTableSelectedRowseleteAria,
                                },
                            },
                        }}
                        columns={columns}
                        {...rest}
                    />
                </MuiThemeProvider>
            </DivFormN1>
        </DivFormN0>
    )
}